<template>
  <div v-if="!loading">
    <form>
      <!-- Quick Navigation -->
      <v-card elevation="2" class="mb-6">
        <v-card-text class="pa-3">
          <div class="text-caption grey--text mb-2">Rýchla navigácia</div>
          <v-chip-group>
            <v-chip small outlined @click="scrollToSection('identifikacia')">
              <v-icon small left>mdi-account-card</v-icon>
              Identifikácia
            </v-chip>
            <v-chip small outlined @click="scrollToSection('zaradenie')">
              <v-icon small left>mdi-door-open</v-icon>
              Zaradenie VO
            </v-chip>
            <v-chip small outlined @click="scrollToSection('rodina')">
              <v-icon small left>mdi-account-group</v-icon>
              Rodina
            </v-chip>
            <v-chip small outlined @click="scrollToSection('byvanie')">
              <v-icon small left>mdi-home</v-icon>
              Bývanie
            </v-chip>
            <v-chip small outlined @click="scrollToSection('vzdelanie')">
              <v-icon small left>mdi-school</v-icon>
              Vzdelanie
            </v-chip>
            <v-chip small outlined @click="scrollToSection('zamestnanie')">
              <v-icon small left>mdi-briefcase</v-icon>
              Zamestnanie
            </v-chip>
            <v-chip small outlined @click="scrollToSection('financie')">
              <v-icon small left>mdi-currency-usd</v-icon>
              Financie
            </v-chip>
            <v-chip small outlined @click="scrollToSection('doklady')">
              <v-icon small left>mdi-file-document</v-icon>
              Doklady
            </v-chip>
          </v-chip-group>
        </v-card-text>
      </v-card>

      <!-- Section 1: Identifikačné údaje -->
      <div id="identifikacia">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="blue-grey darken-2 white--text py-4">
            <v-icon left dark large>mdi-account-card-details</v-icon>
            <div>
              <div class="text-h6">Identifikačné údaje o klientovi</div>
              <div class="text-caption font-weight-light">Základné informácie a priebeh výkonu trestu</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
            <!-- Personal Info Row -->
            <div class="text-subtitle-2 mb-3 grey--text text--darken-2">
              <v-icon small class="mr-1">mdi-account</v-icon>
              Osobné údaje
            </div>
            <v-sheet color="grey lighten-4" rounded class="pa-4 mb-6">
              <v-row>
            <v-col cols="3">
              <v-text-field
                v-model="form.meno_a_priezvisko"
                disabled
                label="Meno a priezvisko"
                name="Meno a priezvisko"
              />
            </v-col>

            <v-col
              v-if="form.birth_number"
              cols="2"
            >
              <v-text-field
                v-model="form.birth_number"
                disabled
                label="Rodné číslo"
                name="Rodné číslo"
              />
            </v-col>

            <v-col
              v-if="'base_number' in form"
              cols="3"
            >
              <v-text-field
                v-model="form.base_number"
                readonly
                label="Základné číslo vo VTOS"
                name="Základné číslo vo VTOS"
              />
            </v-col>

            <v-col cols="3">
              <v-text-field
                v-model="form.birth_date"
                disabled
                label="Dátum narodenia"
                name="Dátum narodenia"
              />
            </v-col>
            <v-col cols="1">
              <v-text-field
                v-model="form.age"
                disabled
                label="Vek"
                name="Vek"
              />
            </v-col>
              </v-row>

              <v-text-field
                v-if="'obmedzenia' in form"
                v-model="form.obmedzenia"
                readonly
                label="Obmedzenia"
                name="Obmedzenia"
                outlined
                dense
              />
            </v-sheet>

            <!-- Sentence Information -->
            <div class="text-subtitle-2 mb-3 grey--text text--darken-2">
              <v-icon small class="mr-1">mdi-gavel</v-icon>
              Informácie o výkone trestu
            </div>
            <v-sheet color="blue lighten-5" rounded class="pa-4 mb-4">

          <v-row>
            <v-col>
              <v-text-field
                v-model="form.nastup_do_vt"
                disabled
                label="Nástup do VT"
                name="Nástup do VT"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.dlzka_trestu"
                disabled
                label="Dĺžka trestu"
                name="Dĺžka trestu"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.recidiva"
                disabled
                label="Recidíva"
                name="Recidíva"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.datum_pp"
                disabled
                label="Dátum PP"
                name="Dátum PP"
              />
            </v-col>
            <v-col>
              <v-switch
                v-model="form.prepusteny_na_pp"
                label="Bol prepustený na PP"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="form.koniec_trestu"
                disabled
                label="Koniec trestu"
                name="Koniec trestu"
              />
            </v-col>
              </v-row>
            </v-sheet>

            <!-- Crime Description -->
            <div class="text-subtitle-2 mb-3 grey--text text--darken-2">
              <v-icon small class="mr-1">mdi-file-document-outline</v-icon>
              Trestná činnosť
            </div>
            <v-sheet color="orange lighten-5" rounded class="pa-4">
              <v-row>
                <v-col>
                  <v-textarea
                    v-model="form.druh_trestnej_cinnosti"
                    auto-grow
                    rows="1"
                    disabled
                    label="Druh trestnej činnosti (paragrafy)"
                    name="Druh trestnej činnosti (paragrafy)"
                    outlined
                  />
                </v-col>
              </v-row>
            </v-sheet>
          </v-card-text>
        </v-card>
      </div>

      <!-- Section 2: Zaradenie VO -->
      <div id="zaradenie">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="green darken-2 white--text py-4">
            <v-icon left dark large>mdi-door-open</v-icon>
            <div>
              <div class="text-h6">Zaradenie do výstupného oddielu</div>
              <div class="text-caption font-weight-light">Evidencia zaradenia a vyradenia z VO</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">t class="pa-6">
            <v-alert
              border="left"
              colored-border
              color="info"
              elevation="1"
              class="mb-4"
            >
              <div class="text-body-2">
                <div class="mb-2">
                  <v-icon small color="info" class="mr-2">mdi-calendar-import</v-icon>
                  <strong>Zaradenie do VO:</strong> dátum zaradenia do výstupného oddielu (vyplniť manuálne)
                </div>
                <div>
                  <v-icon small color="info" class="mr-2">mdi-calendar-export</v-icon>
                  <strong>Vyradenie z VO:</strong> dátum vyradenia z výstupného oddielu (vyplniť manuálne)
                </div>
              </div>
            </v-alert>
            
            <v-card
              v-for="(input, index) in form.zaradenie_vo"
              :key="index"
              outlined
              class="mb-3 pa-4"
            >
              <v-row align="center">
                <v-col cols="3">
                  <date-picker-custom
                    v-model="input.zaradenie_do_vo"
                    name="Dátum od"
                  />
                </v-col>
                <v-col cols="3">
                  <date-picker-custom
                    v-model="input.vyradenie_z_vo"
                    name="Dátum do"
                  />
                </v-col>
                <v-col cols="5">
                  <v-textarea
                    v-model="input.popis"
                    label="Popis"
                    name="Popis"
                    rows="1"
                    auto-grow
                    outlined
                    dense
                  />
                </v-col>
                <v-col cols="1" class="text-center">
                  <v-btn
                    icon
                    color="error"
                    @click="deleteRowZaradenieVO(index)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <v-btn
              text
              color="primary"
              @click="addRowZaradenieVO"
            >
              <v-icon left>mdi-plus</v-icon>
              Pridať záznam
            </v-btn>
          </v-card-text>
        </v-card>
      </div>

      <!-- Diagnostika Header -->
      <v-alert
        color="deep-purple"
        dark
        class="mb-6 text-center"
        prominent
        elevation="2"
      >
        <v-icon large left>mdi-clipboard-pulse</v-icon>
        <span class="text-h5 font-weight-bold">Diagnostika klienta</span>
      </v-alert>

      <!-- Section 3: Rodinná a vzťahová anamnéza -->
      <div id="rodina">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="pink darken-2 white--text py-4">
            <v-icon left dark large>mdi-account-heart</v-icon>
            <div>
              <div class="text-h6">Rodinná a vzťahová anamnéza</div>
              <div class="text-caption font-weight-light">Rodinná situácia a vzťahy</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              <strong>Rodinný stav:</strong> vypĺňané automaticky<br>
              <strong>Popis:</strong> priestor pre dôležité skutočnosti ktoré môžu mať vplyv na recidívu (podporné aj rizikové)<br>
              <strong>Počet detí:</strong> vypĺňané automaticky<br>
              <strong>Odporúčané intervencie:</strong> myslí sa po prepustení
            </div>
          </v-alert>
          
          <v-row>
            <v-col cols="3">
              <v-select
                v-model="form.rodinny_stav"
                label="Rodinný stav"
                name="Rodinný stav"
                :items="selects.rodinny_stav"
                />
            </v-col>
            <v-col cols="9">
              <v-textarea
                v-model="form.rodinny_stav_popis"
                auto-grow
                rows="1"
                label="Popis"
                name="Popis"
                />
            </v-col>
          </v-row>

          <v-text-field
            v-model="form.pocet_deti_celkovo"
            label="Počet detí celkovo"
            name="Počet detí celkovo"
            />

          <v-select
            v-model="form.odporucane_intervencie"
            label="Odporúčané intervencie"
            name="Odporúčané intervencie"
            :items="selects.odporucane_intervencie"
            />
        </v-card-text>
      </v-card>

      <v-card
        v-if="form.kontakty_pocas_trvania_trestu"
        class="my-5"
      >
        <v-card-title>
          Kontakty počas trvania výkonu trestu
        </v-card-title>
        <v-card-text>
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              V kontaktoch sa uvádza obdobie, frekvencia a osoby, resp. organizácie dôležité pre resocializáciu.
              <strong>Príklad:</strong> Manželka od 1/2015-5/2017 2 x mesačne pravidelne každý mesiac.
            </div>
          </v-alert>
          <v-card
            v-for="(input, index) in form.kontakty_pocas_trvania_trestu"
            :key="index"
            class="my-3 mx-auto"
          >
            <v-card-text>
              <v-row>
                <v-col cols="2">
                  <v-text-field
                    v-model="input.pocetnost_pocet"
                    type="number"
                    label="Koľkokrát"
                    name="Koľkokrát"
                  />
                </v-col>
                <v-col cols="2">
                  <v-select
                    v-model="input.pocetnost_jednotka"
                    label="Frekvencia"
                    name="Frekvencia"
                    :items="selects.kontakty.jednotka"
                  />
                </v-col>

                <v-col cols="2">
                  <date-picker-custom
                    v-model="input.datum_od"
                    name="Dátum od"
                  />
                </v-col>
                <v-col cols="2">
                  <date-picker-custom
                    v-model="input.datum_do"
                    name="Dátum do"
                  />
                </v-col>

                <v-spacer />
                <v-btn
                  icon
                  @click="deleteRowKontakty(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="input.popis"
                    label="Popis"
                    name="Popis"
                    rows="1"
                    auto-grow
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>

          <v-btn
            text
            icon
            color="secondary"
            @click="addRowKontakty"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-text>
      </v-card>
      </div>

      <!-- Section 4: Bývanie -->
      <div id="byvanie">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="brown darken-1 white--text py-4">
            <v-icon left dark large>mdi-home-city</v-icon>
            <div>
              <div class="text-h6">Bývanie</div>
              <div class="text-caption font-weight-light">Bývanie pred a po výkone trestu odňatia slobody</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              <strong>Dôležité:</strong> V prípade bezdomovectva alebo segregovanej komunity zachyťte v SWOT analýze (oblasť Bývanie).
            </div>
          </v-alert>
          
          <v-row>
            <v-col cols="9">
              <v-text-field
                v-model="form.trvale_bydlisko"
                label="Trvalé bydlisko"
                name="Trvalé bydlisko"
                />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="form.trvale_bydlisko_popis"
                label="Trvalé bydlisko popis"
                name="Trvalé bydlisko popis"
                :items="selects.byvanie.popis"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="9">
              <v-text-field
                v-model="form.prechodne_bydlisko"
                label="Prechodné bydlisko"
                name="Prechodné bydlisko"
                />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="form.prechodne_bydlisko_popis"
                label="Prechodné bydlisko popis"
                name="Prechodné bydlisko popis"
                :items="selects.byvanie.popis"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="9">
              <v-text-field
                v-model="form.obvykly_pobyt"
                label="Obvyklý pobyt"
                name="Obvyklý pobyt"
                />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="form.obvykly_pobyt_popis"
                label="Obvyklý pobyt popis"
                name="Obvyklý pobyt popis"
                :items="selects.byvanie.popis"
                />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2">
              <v-select
                v-model="form.skusenosti_s_bezdomovectvom"
                label="Skúsenosti s bezdomovectvom"
                name="Skúsenosti s bezdomovectvom"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.byvanie_v_segregovanej_komunite"
                label="Bývanie v segregovanej komunite"
                name="Bývanie v segregovanej komunite"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.riesenie_ubytovania"
                label="Riešenie ubytovania"
                name="Riešenie ubytovania"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.potvrdenie_o_deinfekcnosti"
                label="Potvrdenie o bezinfekčnosti"
                name="Potvrdenie o bezinfekčnosti"
                :items="selects.checkbox"
                />
            </v-col>
          </v-row>

          <v-textarea
            v-model="form.byvanie_popis"
            auto-grow
            rows="1"
            label="Popis"
            name="Popis"
            />
          </v-card-text>
        </v-card>
      </div>

      <!-- Section 5: Vzdelanie -->
      <div id="vzdelanie">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="purple darken-2 white--text py-4">
            <v-icon left dark large>mdi-school</v-icon>
            <div>
              <div class="text-h6">Vzdelanie</div>
              <div class="text-caption font-weight-light">Najvyššie dosiahnuté vzdelanie a odbory</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              <strong>Najvyššie dosiahnuté vzdelanie:</strong> vypĺňané automaticky<br>
              <strong>Odbor a iné vzdelanie:</strong> ak je to relevantné, manuálne doplňte (napr. Kuchár)
            </div>
          </v-alert>
          
          <v-select
            v-model="form.najvyssie_dosiahnute_vzdelanie"
            label="Najvyššie dosiahnuté vzdelanie"
            name="Najvyššie dosiahnuté vzdelanie"
            :items="selects.vzdelanie.najvyssie_dosiahnute_vzdelanie"
            />

          <v-textarea
            v-model="form.odbor"
            auto-grow
            rows="1"
            label="Odbor"
            name="Odbor"
            />

          <v-textarea
            v-model="form.ine_vzdelanie_pred_vtos"
            auto-grow
            rows="1"
            label="Iné vzdelanie (nadobudnuté pred nástupom do VTOS)"
            name="Iné vzdelanie (nadobudnuté pred nástupom do VTOS)"
            />
          </v-card-text>
        </v-card>
      </div>

      <!-- Section 6: Zamestnanie -->
      <div id="zamestnanie">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="teal darken-2 white--text py-4">
            <v-icon left dark large>mdi-briefcase</v-icon>
            <div>
              <div class="text-h6">Zamestnanie</div>
              <div class="text-caption font-weight-light">Pracovná história a evid asúčasný stav</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              <strong>Zamestnaný nepretržite:</strong> automaticky zaškrtnuté ak bol odsúdený zamestnaný celých 12 mesiacov pred nástupom do VTOS<br>
              <strong>Posledný zamestnávateľ:</strong> dôležité pre prípadné kontaktovanie<br>
              <strong>Nelegálna práca:</strong> smeruje k intervenciám v oblasti zamestnanosti
            </div>
          </v-alert>
          
          <v-select
            v-model="form.zamestnany_nepretrzite"
            readonly
            label="Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS"
            name="Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS"
            :items="selects.checkbox"
            />

          <v-textarea
            v-model="form.posledny_zamestnavatel"
            auto-grow
            rows="1"
            label="Posledný zamestnávateľ (pred nástupom do VTOS)"
            name="Posledný zamestnávateľ (pred nástupom do VTOS)"
            />

          <v-textarea
            v-model="form.druh_vykonavanej_prace"
            auto-grow
            rows="1"
            label="Druh vykonávanej práce"
            name="Druh vykonávanej práce"
            />

          <v-row>
            <v-col cols="2">
              <v-select
                v-model="form.evidovany_na_upsvr"
                label="Evidovaný na ÚPSVR"
                name="Evidovaný na ÚPSVR"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.poberatel_dvh_hn"
                label="Poberateľ DVN/HN"
                name="Poberateľ DVN/HN"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.nelegalna_praca"
                label="Nelegálna práca"
                name="Nelegálna práca"
                :items="selects.checkbox"
                />
            </v-col>
          </v-row>

          <v-textarea
            v-model="form.zamestnanie_ine"
            auto-grow
            rows="1"
            label="Iné"
            name="Iné"
          />
          </v-card-text>
        </v-card>
      </div>

      <!-- Section 7: Financie -->
      <div id="financie">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="green darken-2 white--text py-4">
            <v-icon left dark large>mdi-cash-multiple</v-icon>
            <div>
              <div class="text-h6">Financie</div>
              <div class="text-caption font-weight-light">Finančná situácia a záväzky</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              <strong>Dôležité:</strong> V prípade dlhov a exekúcií túto skutočnosť zachyťte v SWOT analýze (oblasť Financie/ohrozenia).<br>
              Ak odsúdený vybavuje dôchodok, zaznamenajte v SWOT (Financie/príležitosti).
            </div>
          </v-alert>
          
          <v-row>
            <v-col cols="2">
              <v-select
                v-model="form.dlhy_a_exekucie"
                label="Dlhy a exekúcie"
                name="Dlhy a exekúcie"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.ma_financie_na_cestu"
                label="Má financie na cestu domov"
                name="Má financie na cestu domov"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.poberatel_dochodkovej_davky"
                label="Poberateľ dôchodkovej dávky"
                name="Poberateľ dôchodkovej dávky"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.dochodok_vo_vybavovani"
                label="Dôchodok vo vybavovaní"
                name="Dôchodok vo vybavovaní"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.dlh_na_zdravotnom"
                label="Dlh na zdravotnom poistení"
                name="Dlh na zdravotnom poistení"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.dlh_na_socialnom"
                label="Dlh na sociálnom poistení"
                name="Dlh na sociálnom poistení"
                :items="selects.checkbox"
                />
            </v-col>
          </v-row>

          <v-textarea
            v-model="form.financie_ine"
            auto-grow
            rows="1"
            label="Iné"
            name="Iné"
            />
        </v-card-text>
      </v-card>
      </div>

      <!-- Section 8: Doklady -->
      <div id="doklady">
        <v-card elevation="3" class="mb-6">
          <v-card-title class="orange darken-2 white--text py-4">
            <v-icon left dark large>mdi-card-account-details</v-icon>
            <div>
              <div class="text-h6">Doklady</div>
              <div class="text-caption font-weight-light">Osobné doklady a identifikácia</div>
            </div>
          </v-card-title>
          <v-card-text class="pa-6">
          <v-alert
            dense
            text
            color="info"
            icon="mdi-information-outline"
            class="mb-4"
          >
            <div class="text-caption">
              <strong>Občiansky preukaz:</strong> zadajte dátum platnosti a označte ak požiadal o vybavenie<br>
              <strong>Preukaz zdravotného poistenia:</strong> označte či fyzicky vlastní alebo požiadal o vybavenie
            </div>
          </v-alert>
          
          <v-row>
            <v-col cols="3">
              <date-picker-custom
                v-model="form.obciansky_preukaz_platnost"
                name="Občiansky preukaz platnosť do"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.obciansky_preukaz_poziadal_o_vybavenie"
                label="Občiansky preukaz požiadal/a o vybavenie"
                name="Občiansky preukaz požiadal/a o vybavenie"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="3">
              <v-select
                v-model="form.zdravotna_poistovna"
                label="Zdravotná poisťovňa"
                name="Zdravotná poisťovňa"
                :items="selects.zdravotna_poistovna"
              />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.preukaz_zdravotneho_poistenia_vlastni"
                label="Preukaz zdravotného poistenia fyzicky vlastní"
                name="Preukaz zdravotného poistenia fyzicky vlastní"
                :items="selects.checkbox"
                />
            </v-col>
            <v-col cols="2">
              <v-select
                v-model="form.preukaz_zdravotneho_poistenia_poziadal_o_vybavenie
                "
                label="Preukaz zdravotného poistenia požiadal o vybavenie"
                name="Preukaz zdravotného poistenia požiadal o vybavenie"
                :items="selects.checkbox"
                />
            </v-col>
          </v-row>

          <v-textarea
            v-model="form.doklady_ine"
            auto-grow
            rows="1"
            label="Iné"
            name="Iné"
            />
        </v-card-text>
      </v-card>
      </div>

      <!-- Form actions with unsaved changes indicator -->
      <v-divider class="my-6" />
      <FormActions
        ref="formActions"
        v-if="!form.closed"
        :is-dirty="isDirty"
        :loading="loading"
        :fixed="false"
        save-text="Uložiť"
        @save="updateItem"
      />
    </form>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="UdajeOKlientovi" />
  </div>
</template>

<script>
import { ref, reactive, onMounted } from '@vue/composition-api';
import { useRoute } from '@/composables/useRouter.js';
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../components/FormSkeleton.vue";
import DatePickerCustom from "@/components/DatePickerCustom.vue";
import FormActions from "@/components/FormActions.vue";
import { useIapszForm } from "@/composables/useIapszForm.js";
import { useFormDirty } from "@/composables/useFormDirty.js";

const apiService = new APIService();

export default {
  components: {
    "form-skeleton-component": FormSkeleton,
    "date-picker-custom": DatePickerCustom,
    DatePickerCustom,
    FormActions,
  },
  
  setup() {
    const route = useRoute();
    
    // Use composables
    const { loading, snackbar_saved, snackbar_error, setLoading, handleSaveSuccess, handleSaveError } = useIapszForm();
    
    // Form actions ref
    const formActions = ref(null);
    
    // Form state
    const form = ref({
      id: null,
      meno_a_priezvisko: "",
      kontakty_pocas_trvania_trestu: [
        {
          popis: "",
        },
      ],
      rodina_a_blizke_osoby: [
        {
          type: "",
          meno: "",
          priezvisko: "",
          adresa: "",
          kontakt: "",
          ine: "",
        },
      ],
      blizke_osoby_string: "{}",
    });
    
    // Track dirty state for unsaved changes warning
    const initialForm = ref({});
    const { isDirty, markAsPristine, enableBrowserWarning } = useFormDirty(
      initialForm,
      form,
      { deep: true }
    );
    
    // Enable browser warning on page unload
    enableBrowserWarning();

    // Select options
    const selects = reactive({
      zdravotna_poistovna: [
        "24 – DÔVERA zdravotná poisťovňa, a.s.",
        "25 – VŠEOBECNÁ zdravotná poisťovňa, a.s.",
        "27 – UNION zdravotná poisťovňa, a.s.",
        ""
      ],
      kontakty: {
        jednotka: [
          "Týždenne",
          "Mesačne",
          "Ročne"
        ]
      },
      checkbox: [
        {
          text: "áno",
          value: true
        },
        {
          text: "nie",
          value: false
        },
        {
          text: "nevyplnené",
          value: null
        }
      ],
      rodinny_stav: [
        "slobodný/slobodná",
        "ženatý/vydatá",
        "rozvedený/rozvedená",
        "vdovec/vdova",
        "druh/družka",
        "iné",
      ],
      rodina_a_blizke_osoby: {
        typ: [
          "matka",
          "otec",
          "plnoleté dieťa",
          "partner(ka)",
          "súrodenec",
          "iné blízke osoby/vzťah ku klientovi",
        ],
      },
      byvanie: {
        popis: [
          "vlastník",
          "nájomca",
          "bezdomovec",
          "u rodičov",
          "nemá",
          "iné",
        ],
      },
      vzdelanie: {
        najvyssie_dosiahnute_vzdelanie: [
          "III. stupeň vysokej školy",
          "II. stupeň vysokej školy",
          "I. stupeň vysokej školy",
          "úplné stredné všeobecné vzdelanie s maturitou (gymnázium)",
          "úplné stredné odborné vzdelávanie s maturitou",
          "stredné odborné vzdelanie bez maturity s výučným listom/resp. záučným listom",
          "špeciálna škola",
          "ukončená základná škola",
          "neukončený II. stupeň základnej školy",
          "neukončený I. stupeň základnej školy",
          "negramotný",],
      },
      odporucane_intervencie: [
        "CAN syndróm",
        "Rodičovské zručnosti",
        "Výchovné poradenstvo",
        "Domáce násilie",
        "Sanácia rodinného prostredia",
        "Krízová intervencia",
        "Konkrétna sociálna služba (448/2008)",
        "Svojpomocná skupina",
        "Ambulantná starostlivosť (druh)",
        "Rezidenciálna starostlivosť (druh)",
        "Poradenstvo v oblasti práce",
        "Poradenstvo v oblasti ubytovania",
        "Poradenstvo v oblasti financií",
        "Poradenstvo v oblasti práva",
        "Poradenstvo v oblasti vzťahov",
        "Poradenstvo v oblasti sebarealizácie",
        "Poradenstvo v oblasti závislostí",
        "Podpora rodičovských zručností",
        "Iné"
      ],
    });

    // Manual/help text
    const manual = reactive({
      base_number: {
        nazov: "Základné číslo vo VTOS",
        charakteristika: [
          "Základné číslo vo VTOS – je uvedené aktuálne základné číslo",
          "- v prípade recidívy a opätovného umiestnenia vo výstupnom oddiele sa v IAPSZ z.č. aktualizuje",
          "- v prípade recidívy a opätovného umiestnenia vo výstupnom oddiele sa v IAPSZ údaje aktualizujú – v prípade už založeného IAPSZ."
        ],
      },
      obmedzenia: {
        nazov: "Obmedzenia",
        charakteristika: [
          "položka je vypĺňaná automaticky zo systému VVVT, nie je možné ju dopĺňať (GDPR)"
        ]
      },

      zaradenie_do_vo: {
        nazov: "Zaradenie do VO",
        charakteristika: [
          "dátum zaradenia do výstupného oddielu(vyplniť manuálne)"
        ]
      },

      vyradenie_z_vo: {
        nazov: "Vyradenie z VO",
        charakteristika: [
          "dátum vyradenia z výstupného oddielu (vyplniť manuálne)"
        ]
      },

      rodinny_stav: {
        nazov: "Rodinný stav",
        charakteristika: ["vypĺňané automaticky"]
      },

      rodinny_stav_popis: {
        nazov: "Popis",
        charakteristika: ["priestor pre dôležité skutočnosti ktoré môžu mať vplyv na recidívu (podporné aj rizikové)"]
      },

      pocet_deti_celkovo: {
        nazov: "Počet detí celkovo",
        charakteristika: ["vypĺňané automaticky"]
      },

      odporucane_intervencie: {
        nazov: "Odporúčané poradenstvo",
        charakteristika: [
          "myslí sa po prepustení",
        ]
      },

      kontakty_pocas_trvania: {
        nazov: "Kontakty počas trvania výkonu trestu",
        charakteristika: [
          "V kontaktoch sa uvádza obdobie, frekvencia a osoby, resp. organizácie dôležité pre resocializáciu. (napr. Manželka od 1/2015-5/2017 2 x mesačne pravidelne každý mesiac. Od 6/2017.)"
        ]
      },

      trvale_bydlisko: {
        nazov: "Trvalé bydlisko",
        charakteristika: [
          "-	vypĺňané automaticky",
          "-	podľa trvalého bydliska sa automaticky určuje príslušný UPSVR kde bude sprístupnené IAPSZ po prepustení (je možnosť zmeniť príslušnosť UPSVR manuálne)"
        ]
      },

      trvale_bydlisko_popis: {
        nazov: "Trvalé bydlisko popis",
        charakteristika: [
          "-	uvádzajú sa dôležité skutočnosti viažuce sa k bydlisku (napr. Len na 6 mesiacov, byt v dražbe a pod.)",
          "-	ak je to relevantné, príležitosti a ohrozenia je potrebné doplniť aj v SWOT analýze v časti bývanie"
        ]
      },

      prechodne_bydlisko: {
        nazov: "Prechodné bydlisko",
        charakteristika: [
          "vypĺňané automaticky"
        ]
      },

      prechodne_bydlisko_popis: {
        nazov: "Prechodné bydlisko popis",
        charakteristika: [
          "-	uvádzajú sa dôležité skutočnosti viažuce sa k prechodnému pobytu (napr. Len na 6 mesiacov, byt v dražbe a pod.)",
          "-	ak je to relevantné, príležitosti a ohrozenia je potrebné doplniť aj v SWOT analýze v časti bývanie"
        ]
      },

      obvykly_pobyt: {
        nazov: "Obvyklý pobyt",
        charakteristika: [
          "vypĺňané automaticky"
        ]
      },
      obvykly_pobyt_popis: {
        nazov: "Obvyklý pobyt popis",
        charakteristika: [
          "-	uvádzajú sa dôležité skutočnosti viažuce sa k prechodnému pobytu (napr. Len na 6 mesiacov, byt v dražbe a pod.)",
          "-	ak je to relevantné, príležitosti a ohrozenia je potrebné doplniť aj v SWOT analýze v časti bývanie"
        ]
      },

      skusenosti_s_bezdomovectvom: {
        nazov: "Skúsenosti s bezdomovectvom",
        charakteristika: [
          "pole sa zaškrtne v prípade ak mal odsúdený minulú skúsenosť s bezdomovectvom"
        ]
      },

      byvanie_v_segregovanej_komunite: {
        nazov: "Bývanie v segregovanej komunite",
        charakteristika: [
          "pole sa zaškrtne v prípade ak odsúdený má pobyt v segregovanej komunite"
        ]
      },

      riesenie_ubytovania: {
        nazov: "Riešenie ubytovania",
        charakteristika: [
          "pole sa zaškrtne v prípade ak si odsúdený aktuálne rieši bývanie"
        ]
      },

      potvrdenie_o_deinfekcnosti: {
        nazov: "Potvrdenie o bezinfekčnosti",
        charakteristika: [
          "pole sa zaškrtne v prípade ak odsúdený potvrdenie má (resp. bude mať pred prepustením)"
        ]
      },

      byvanie_popis: {
        nazov: "Popis",
        charakteristika: [
          "uvádzajú sa dôležité skutočnosti viažuce sa k bývaniu (odsúdený po prepustení má zabezpečené bývanie na týždeň v nocľahárni smutná vŕba, 1.7. priletí brat odsúdeného z GB a chcú riešiť spoločne prenájom (z dôvodu financií). Na 2 mesiace nemá zabezpečené bývanie. Čakáme na vyjadrenie možnosti bývania miestnej fary."
        ]
      },

      najvyssie_dosiahnute_vzdelanie: {
        nazov: "Najvyššie dosiahnuté vzdelanie",
        charakteristika: [
          "vypĺňané automaticky"
        ]
      },

      odbor: {
        nazov: "Odbor",
        charakteristika: [
          "ak je to relevantné, manuálne treba doplniť odbor"
        ]
      },

      ine_vzdelanie_pred_vtos: {
        nazov: "Iné vzdelanie (nadobudnuté pred nástupom do VTOS)",
        charakteristika: [
          "ak je to relevantné, manuálne treba doplniť (napr. Kuchár)"
        ]
      },

      zamestnany_nepretrzite: {
        nazov: "Zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS",
        charakteristika: [
          "položka sa automaticky zaškrtne ak bol odsúdený zamestnaný nepretržite celých 12 mesiacov pred nástupom do VTOS."
        ]
      },

      posledny_zamestnavatel: {
        nazov: "Posledný zamestnávateľ",
        charakteristika: ["Treba vyplniť posledného zamestnávateľa pred nástupom odsúdeného do VTOS. Položka je dôležitá pre prípadne kontaktovanie zamestnávateľa a smerovanie odsúdeného."]
      },

      druh_vykonavanej_prace: {
        nazov: "Druh vykonávanej práce",
        charakteristika: ["Treba vyplniť akú prácu odsúdený vykonával (drevorubač, obkladač, kosec a pod.)"]
      },

      evidovany_na_upsvr: {
        nazov: "Evidovaný na ÚPSVR",
        charakteristika: [
          "Treba označiť v prípade, že bol odsúdený pred nástupom do VTOS evidovaný na ÚPSVR"
        ]
      },

      poberatel_dvh_hn: {
        nazov: "Poberateľ DVN/HN",
        charakteristika: [
          "Treba označiť v prípade, že bol odsúdený pred nástupom do VTOS poberateľ dávok pomoci v hmotnej núdzi"
        ]
      },

      nelegalna_praca: {
        nazov: "Nelegálna práca",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má skúsenosť s prácou „na čierno“ bez zmluvy. Položka smeruje charakter intervencií v oblasti zamestnanosti (dôvody nelegálnej práce, eliminácia dôvodov (napr. exekúcie), nevýhody nelegálnej práce (sociálne zabezpečenie, úrazy a pod.)"
        ]
      },

      dlhy_a_exekucie: {
        nazov: "Dlhy a exekúcie",
        charakteristika: [
          "Treba označiť v prípade, že má odsúdený dlhy a exekúcie. V prípade dlhov a exekúcií je dôležité túto skutočnosť zachytiť v SWOT analýze (oblasť Financie/ohrozenia)"
        ]
      },

      ma_financie_na_cestu: {
        nazov: "Má financie na cestu domov",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má dostatok finančných prostriedkov na cestu domov."
        ]
      },

      poberatel_dochodkovej_davky: {
        nazov: "Poberateľ dôchodkovej dávky",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený je poberateľ dôchodkovej dávky."
        ]
      },

      dochodok_vo_vybavovani: {
        nazov: "Dôchodok vo vybavovaní",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený spustil proces vybavenia si dôchodkovej dávky. Túto skutočnosť treba zaznamenať v SWOT analýze (oblasť Financie/príležitosti)."
        ]
      },

      dlh_na_zdravotnom: {
        nazov: "Dlh na zdravotnom poistení",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má dlh na zdravotnom poistení. Túto skutočnosť je dôležité zaznamenať v SWOT analýze (oblasť Financie/ohrozenia). Zároveň je dôležité naplánovať si kroky na riešenie dlhu (napr. splátkový kalendár)."
        ]
      },

      dlh_na_socialnom: {
        nazov: "Dlh na sociálnom poistení",
        charakteristika: [
          "Treba označiť v prípade, že odsúdený má dlh v sociálnej poisťovni. Túto skutočnosť je dôležité zaznamenať v SWOT analýze (oblasť Financie/ohrozenia). Zároveň je dôležité naplánovať si kroky na riešenie dlhu (napr. splátkový kalendár)."
        ]
      },

      financie_ine: {
        nazov: "Iné",
        charakteristika: [
          "Do tejto časti je možné doplniť akékoľvek dôležité skutočnosti viažuce sa k financiám."
        ]
      },

      obciansky_preukaz_platnost: {
        nazov: "Občiansky preukaz platnosť do",
        charakteristika: [
          "Treba označiť v kalendári dátum, do kedy má odsúdený platný občiansky preukaz."
        ]
      },

      obciansky_preukaz_poziadal_o_vybavenie: {
        nazov: "Občiansky preukaz požiadal/a o vybavenia",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený podal žiadosť o vybavenie si občianskeho preukazu."
        ]
      },

      preukaz_zdravotneho_poistenia_vlastni: {
        nazov: "Preukaz zdravotného poistenia fyzicky vlastní",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený fyzicky vlastní preukaz zdravotného poistenia."
        ]
      },

      preukaz_zdravotneho_poistenia_poziadal_o_vybavenie: {
        nazov: "Preukaz zdravotného poistenia požiadal o vybavenie",
        charakteristika: [
          "Treba označiť v prípade ak odsúdený podal žiadosť o vybavenie si preukazu zdravotného poistenia."
        ]
      },

      doklady_ine: {
        nazov: "Iné",
        charakteristika: [
          "Do tejto časti je možné doplniť akékoľvek dôležité skutočnosti viažuce sa k dokladom."
        ]
      }
    });

    // Methods
    const getItem = () => {
      setLoading(true);
      apiService
        .getIapszUdajeOKlientovi(route.params.id)
        .then((response) => {
          form.value = response;
          initialForm.value = JSON.parse(JSON.stringify(response));
          markAsPristine(); // Mark as pristine after loading
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    };

    const updateItem = () => {
      apiService
        .updateIapszUdajeOKlientovi(form.value, route.params.id)
        .then(
          () => {
            handleSaveSuccess();
            markAsPristine(); // Mark as pristine after successful save
            if (formActions.value) {
              formActions.value.showSuccess();
            }
          },
          () => {
            handleSaveError();
            if (formActions.value) {
              formActions.value.showError();
            }
          }
        );
    };

    const addRowKontakty = () => {
      form.value.kontakty_pocas_trvania_trestu.push({
        udaje_o_klientovi: form.value.id,
        pocetnost_pocet: null,
        pocetnost_jednotka: null,
        datum_od: null,
        datum_do: null,
        popis: null,
      });
    };
    
    const deleteRowKontakty = (index) => {
      form.value.kontakty_pocas_trvania_trestu.splice(index, 1);
    };

    const addRowZaradenieVO = () => {
      form.value.zaradenie_vo.push({
        udaje_o_klientovi: form.value.id,
        zaradenie_do_vo: null,
        vyradenie_z_vo: null,
        popis: "",
      });
    };
    
    const deleteRowZaradenieVO = (index) => {
      form.value.zaradenie_vo.splice(index, 1);
    };

    const scrollToSection = (sectionId) => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
    
    // Lifecycle
    onMounted(() => {
      getItem();
    });
    
    return {
      // State
      loading,
      snackbar_saved,
      snackbar_error,
      form,
      selects,
      manual,
      isDirty,
      formActions,
      
      // Methods
      updateItem,
      addRowKontakty,
      deleteRowKontakty,
      addRowZaradenieVO,
      deleteRowZaradenieVO,
      scrollToSection,
    };
  },

  beforeRouteLeave(to, from, next) {
    if (this.isDirty) {
      if (window.confirm('Máte neuložené zmeny. Naozaj chcete odísť?')) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
</script>